
import p1 from "../../assets/adds/p1.png";
import p2 from "../../assets/adds/p2.png";
import p3 from "../../assets/adds/p3.webp";
import p4 from "../../assets/adds/p4.webp";
import p5 from "../../assets/adds/p5.webp";
import p6 from "../../assets/adds/p6.webp";
import p7 from "../../assets/adds/p7.webp";
import p8 from "../../assets/adds/p8.webp";
import p9 from "../../assets/adds/p9.webp";


export const posterData = [

    {
        image: p1,
        whatsapp: "916366366971",
        email: "info@travelbell.in",
        website: "https://www.travelbell.in/",
        phone: "916366366971"
    },
    {
        image: p2,
        whatsapp: "01140752200",
        email: "reservations@amritara.co.in",
        website: "https://www.amritara.co.in",
        phone: "01140752200"
    },
    {
        image: p3,
        whatsapp: "919831322179",
        email: "prakash@neptuneholidays.com",
        website: "https://www.gowithneptune.com",
        phone: "919831322179"
    },
    {
        image: p4,
        whatsapp: "919600935125",
        email: "sales@turtledownunder.com.au",
        website: "https://www.turtledownunder.com.au",
        phone: "919600935125"
    },
    {
        image: p5,
        whatsapp: "919680010289",
        email: "rayomand.kasad@satgurutravel.com",
        website: "https://www.satguruholidays.com",
        phone: "919680010289"
    },
    {
        image: p6,
        whatsapp: "919899550346",
        phone: "919899550346",
        email: "sales@europeoustours.com",
        website: "https://europeous.com/"
    },
    {
        image: p7,
        whatsapp: "911123553116",
        phone: "911123553116",
        email: "info@reachbhutan.com",
        website: "https://www.reachbhutan.com"
    },
    {
        image: p8,
        whatsapp: "918141488868",
        phone: "918141488868",
        email: "inquiry@hotelbox.in",
        website: "https://www.hotelbox.in"
    },
    {
        image: p9,
        whatsapp: "917011257590",
        phone: "917011257590",
        email: "b2bdmc@holidaymoods.net",
        website: "https://www.holidaymoods.net"
    },
];
